module.exports = "<div class=\"login-wrap\" *ngIf=\"url\">\r\n  <iframe [src]=\"url | safe\" frameborder=\"0\"></iframe>\r\n</div>\r\n"